


































import { Component, Vue, Ref } from 'vue-property-decorator'
import WeekForm from '../components/weekForm/index.vue'
import { getWeekPlanInfo, addWeekPlan, delPlan } from '@/api/week'
import AIDraw from '@/components/AIDraw/index.vue'
import ConfirmModal from '@/components/AIDraw/ConfirmModal.vue'
import AIHelper from '@/components/AIDraw/AIHelper.vue'
const defaultForm = {}

@Component({
  components: {
    WeekForm,
    AIDraw,
    ConfirmModal,
    AIHelper,
  },
  beforeRouteLeave(this: any, to: any, from: any, next: any) {
    // 未提交状态，自动保存
    if (!this.submitted) {
      this.$refs.weekFormRef?.handleAutoSave()
    }
    if (this.isChange()) {
      this.$confirm({
        cancelText: '放弃',
        okText: '继续编辑',
        content: '系统检测到您还未提交，确定放弃已编辑的内容吗？',
        onCancel: () => {
          this.showPage = false
          this.$nextTick(() => {
            next()
          })
        },
        onOk: () => {
          next(false)
        },
      })
    } else {
      this.showPage = false
      this.$nextTick(() => {
        next()
      })
    }
  },
})
export default class editWeeklyPlan extends Vue {
  @Ref('weekFormRef')
  private weekFormRef!: any

  formData: any = { ...defaultForm }
  private submitLoading = false
  get IsEnterprise() {
    return this.$store.state.user.userInfo.userType === 0
  }
  get showDel() {
    return this.formData.id && this.formData.isSubmit == 0
  }

  isChange() {
    const formData = this.weekFormRef.getFormData()
    // formData没值，放行
    if (!formData) return false
    const {
      thisWeekContent: oldThisWeekContent,
      nextWeekContent: oldNextWeekContent,
      helpContent: oldHelpContent,
    } = this.formData
    const { thisWeekContent, nextWeekContent, helpContent, isSubmit } = formData
    // 只要一个有值改变并且没有点击提交，拦截
    return (
      (thisWeekContent !== oldThisWeekContent ||
        nextWeekContent !== oldNextWeekContent ||
        helpContent !== oldHelpContent) &&
      !this.submitted &&
      isSubmit != 0
    )
  }
  private showPage = true
  cancel() {
    this.$router.push('/weekPlan/index')
  }
  private submitted: boolean = false
  async submitData() {
    const formData = this.weekFormRef.getFormData()
    if (!formData) return
    const {
      thisWeekContent,
      nextWeekContent,
      helpContent,
      businessAttachmentList = [],
    } = formData
    if (!thisWeekContent && !nextWeekContent && !helpContent) {
      return this.$message.error('请填写计划内容')
    }
    this.submitLoading = true
    const [err] = await addWeekPlan({
      ...formData,
      businessAttachmentList: (businessAttachmentList || []).map(
        (item: any) => ({
          attachmentName: item.attachmentName,
          attachmentUrl: item.attachmentUrl,
        }),
      ),
      isSubmit: 1,
    })
    this.submitLoading = false
    if (err) {
      // 日志已提交，需刷新页面
      if (err.data.status == '52040') {
        this.formData.isSubmit = 1
        this.submitted = true
        this.$message.success(err.data.message)
        this.cancel()
      }
      return
    }
    this.formData.isSubmit = 1
    this.submitted = true
    this.$message.success('提交成功')
    this.cancel()
  }
  async getDetailById() {
    const { id } = this.$route.params
    const [err, res] = await getWeekPlanInfo(id as string)
    if (err) return
    this.formData = { ...res }
    this.weekFormRef.setFormData(res)
  }
  handleDel() {
    this.$confirm({
      content: '确定要删除当前计划?',
      onOk: async () => {
        const [err] = await delPlan(this.formData.id)
        if (!err) {
          this.formData.id = ''
          this.submitted = true
          this.$message.success('删除成功!')
          this.cancel()
        }
      },
    })
  }
  private showAi: boolean = false
  openAi(value: boolean) {
    this.showAi = value
  }
  onCloseDraw() {
    this.showAi = false
  }
  private aiResult: any = ''
  onConfirm(value: any) {
    if (value === 0) {
      this.weekFormRef.formData.thisWeekContent = this.aiResult
    }
    if (value === 1) {
      this.weekFormRef.formData.thisWeekContent += this.aiResult
    }
  }
  private showConfirm: boolean = false
  onResult(value: any) {
    this.aiResult = value
    this.showConfirm = true
  }
  created() {
    this.getDetailById()
  }
}
